import React from 'react';
import parser from 'ua-parser-js';
import { isClient } from '../../settings';
import { documentGetCookie } from '../../cookie';

export const RequestContext = React.createContext({});
RequestContext.displayName = 'Request';

const parseUserAgent = (str) =>
  parser(
    str ||
      (isClient && window.navigator && window.navigator.userAgent
        ? window.navigator.userAgent
        : ''),
  );
export const RequestContextProvider = ({ staticContext, children }) => {
  const { request, token, state, setStatus } = staticContext || {};
  const log = request
    ? request.log
    : { debug: () => {}, error: () => {}, warn: () => {}, info: () => {} };

  const userAgent = parseUserAgent(request ? request.headers['user-agent'] : '');
  const { device } = userAgent;
  userAgent.isDesktop = !['tablet', 'mobile'].includes(device.type);
  userAgent.isTablet = device.type === 'tablet';
  userAgent.isMobile = device.type === 'mobile';

  const accessToken = token || documentGetCookie('access_token') || null;

  return (
    <RequestContext.Provider
      value={{
        accessToken,
        userAgent,
        state,
        setStatus,
        log,
      }}
    >
      {children}
    </RequestContext.Provider>
  );
};
